import {getUserConfig} from "@utility/utils";

const initialState = {
    list: [],
    total: 0,
    loading: false,
    submitting: false,
    searchParams: {
        refresh: false,
        status_tag: "",
        operatorID: "",
        start_date: "",
        end_date: "",
        page: 1,
        count: 30,
        ...getUserConfig("loopNotice")
    }
}

const loopReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'LOOP_DATA':
            return {
                ...state,
                ...action.payload
            }
        case 'LOOP_DATA_RELOAD':
            return {
                ...state,
                searchParams: {
                    ...state.searchParams,
                    refresh: true
                }
            }
        case 'LOOP_DATA_INIT':
            return {
                ...initialState,
                searchParams: {
                    ...initialState.searchParams,
                    ...getUserConfig("loopNotice")
                }
            }
        default:
            return {...state};
    }
}

export default loopReducer
